import React, { Component } from "react";
import PharmacyBasicInfoView from "./PhramacyBasicInfoView";

export default class PharmacyBasicInfoContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      details: {}
    };
  }

  render() {
    const { details } = this.props;

    return <>{details && <PharmacyBasicInfoView details={details} />}</>;
  }
}
